import { render } from "./template.md?vue&type=template&id=6af1a1b2"
import script from "./template.md?vue&type=script&lang=js"
export * from "./template.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__